import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../../core/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'src/app/core/services/cookie.service';


@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

  notificationItems: Array<{}>;
  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  constructor(private router: Router, private authService: AuthenticationService, private translate: TranslateService, private cookieService: CookieService) { }

  ngOnInit() {
    this.translate.use(this.translate.getBrowserLang());
    // get the notifications
    this.openMobileMenu = false;
  }


  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.openMobileMenu = !this.openMobileMenu;
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    this.authService.logout();
    this.router.navigate(['/account/login']);
  }

  setEnglish(){
    this.translate.use(this.translate.getBrowserLang());
    this.cookieService.setCookie('lang', 'es', 100);
  
  } 

  setFrench(){
    this.translate.use('fr');
    this.cookieService.setCookie('lang', 'fr', 100);
  } 
}
